import React from 'react';
import { WizardContextProps } from 'interfaces/wizard/wizard';

const WizardContext = React.createContext<WizardContextProps>({} as WizardContextProps);

export default WizardContext;
